import styled from '@emotion/styled';
import { DrawerPosition } from './Drawer';
export const Wrapper = styled.div `
  --background: ${({ backgroundColor }) => backgroundColor};
  --color: ${({ color }) => color};
  background: var(--background);
  color: var(--color);
  backdrop-filter: blur(10px);
  border-radius: ${({ minHeight }) => minHeight === '100%' ? '0' : 'var(--radius-5) var(--radius-5) 0 0'};
  box-shadow: 0 2px 8px 0 rgb(0 0 0 / 50%);
  display: flex;
  flex-direction: column;
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  min-height: ${({ minHeight }) => minHeight};
  overflow-y: ${({ overflowY }) => overflowY};
  padding: 0;
  position: absolute;

  transition-property: top, right, bottom;
  transition-duration: 250ms;
  transition-timing-function: ease;
  width: 100%;

  ${({ position }) => position === DrawerPosition.BOTTOM &&
    `
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);

      &.transition-appear {
        bottom: -100%;
      }

      &.transition-appear-active,
      &.transition-appear-done {
        bottom: 0;
      }
    `}

  ${({ position }) => position === DrawerPosition.RIGHT &&
    `
      border-radius: var(--border-radius);
      box-shadow: none;
      top: 0;
      bottom: 0;
      right: 0;

      &.transition-appear {
        right: -100%;
      }
      &.transition-appear-active,
      &.transition-appear-done {
        right: 0;
      }
    `}
`;
export const Header = styled.div `
  display: flex;
  flex: 0;
  flex-basis: 60px;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
`;
export const BackButtonWrapper = styled.div `
  flex: 0;
  [dir='rtl'] & {
    transform: rotate(180deg);
  }
  min-width: 50px;
`;
export const Title = styled.div `
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: bold;
`;
export const CloseButtonWrapper = styled.div `
  flex: 0;
  min-width: 50px;
`;
export const HorizontalDivider = styled.div `
  border-bottom: solid 1px color-mix(in srgb, currentColor 15%, transparent);
  margin: 0 20px;
  padding: 0;
  height: 1px;
`;
export const DrawerInner = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  padding: ${({ padding }) => padding};
  overflow: ${({ overflow }) => overflow};
  overscroll-behavior: contain;
  padding-bottom: calc(
    ${({ paddingBottom }) => paddingBottom} + env(safe-area-inset-bottom)
  );
  position: relative;
  min-height: 0;
`;
